// F-MOTOR-RESERVAS.3.0.3 — Tokens oficiais do Brand System Rede Hospeda.
// Fonte única de verdade para cores, tipografia e ativos. Reaproveita BRAND de lib/brand.js.
// Preparado para F-SAAS: `DEFAULT_BRAND` servirá como fallback quando `BrandProvider`
// receber uma configuração de tenant via contexto.

import { BRAND } from "@/lib/brand";

export const DEFAULT_BRAND = {
  id: "rede-hospeda",
  name: BRAND.name,
  tagline: BRAND.tagline,
  assets: {
    logo: BRAND.logoUrl,
    logoMark: BRAND.logoMarkUrl,
    logoWhite: BRAND.logoWhiteUrl,
    logoPng: BRAND.logoPngUrl,
    favicon: BRAND.faviconUrl,
    appleTouchIcon: BRAND.appleTouchIconUrl,
    ogImage: BRAND.ogImage,
  },
  colors: {
    primary: BRAND.colors.azul,          // #083A6B
    primaryDark: BRAND.colors.azulProfundo, // #052B50
    accent: BRAND.colors.dourado,        // #D4A652
    accentDark: "#B8902F",
    cream: BRAND.colors.creme,           // #F5F1E8
    muted: BRAND.colors.cinza,           // #6B7280
    surface: "#FFFFFF",
    ink: "#1C1917",
  },
  fonts: {
    title: "Montserrat, -apple-system, BlinkMacSystemFont, 'Open Sans', Arial, sans-serif",
    body: "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
  },
};

// Mapa cor-nome → CSS variable (injetado pelo BrandProvider em :root).
export function brandToCssVars(brand = DEFAULT_BRAND) {
  const c = brand.colors;
  return {
    "--brand-primary": c.primary,
    "--brand-primary-dark": c.primaryDark,
    "--brand-accent": c.accent,
    "--brand-accent-dark": c.accentDark,
    "--brand-cream": c.cream,
    "--brand-muted": c.muted,
    "--brand-surface": c.surface,
    "--brand-ink": c.ink,
    "--brand-font-title": brand.fonts.title,
    "--brand-font-body": brand.fonts.body,
  };
}
